(() => {
  function message(subtotal) {
    const dollars = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:cents % 100 ? 2 : 0,maximumFractionDigits:2}).format(cents/100);
    if (subtotal <= 0) return 'Buy more, save more · Up to 25% off';
    if (subtotal < 10000) return 'Spend '+dollars(10000-subtotal)+' more to unlock 15% off';
    if (subtotal < 25000) return '15% unlocked · Spend '+dollars(25000-subtotal)+' more for 20% off';
    if (subtotal < 40000) return '20% unlocked · Spend '+dollars(40000-subtotal)+' more for 25% off';
    return '25% off unlocked · Your highest tier';
  }
  function render(root, subtotal) {
    if (Date.now() >= Date.parse(root.dataset.ends)) { root.hidden=true; return; }
    root.querySelector('[data-tier-message]').textContent=message(subtotal);
    root.querySelectorAll('[data-tier-min]').forEach(el=>el.classList.toggle('is-earned',subtotal>=Number(el.dataset.tierMin)));
  }
  function init() {
    document.querySelectorAll('[data-alva-tierbar]').forEach(root=>{
      if(root.dataset.bound) return;
      root.dataset.bound='true';
      render(root,Number(root.dataset.subtotal)||0);
    });
  }
  if (window.alvaTierbarBound) { init(); return; }
  window.alvaTierbarBound=true;
  let pending;
  async function refresh() {
    const root=document.querySelector('[data-alva-tierbar]');
    if(!root) return;
    try {
      const response=await fetch(root.dataset.cartRoot+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok) return;
      const cart=await response.json();
      if(cart.currency!=='USD') return;
      const subtotal=cart.items.filter(item=>!item.gift_card).reduce((sum,item)=>sum+item.final_line_price,0);
      document.querySelectorAll('[data-alva-tierbar]').forEach(el=>render(el,subtotal));
    } catch(_) {}
  }
  function schedule(){clearTimeout(pending);pending=setTimeout(refresh,150);}
  ['cart:change','cart:refresh','variant:add'].forEach(name=>document.addEventListener(name,schedule));
  document.addEventListener('shopify:section:load',()=>{init();schedule();});
  window.addEventListener('pageshow',schedule);
  document.addEventListener('keydown',event=>{if(event.key==='Escape') document.querySelectorAll('.alva-tierbar__details[open]').forEach(el=>el.open=false);});
  init();
})();